import * as React from 'react'
import { ReactElement } from 'react'
import { LineItemProps } from './LineItem'
import { TravelListItemDto } from '../../../../../config/registrationConfig'
import { Stack, Text } from '@fluentui/react'
import { Avatar, Badge, Tooltip } from '@fluentui/react-components'
import { CalendarMonthRegular, MoneyRegular, VehicleCarProfileRegular } from '@fluentui/react-icons'
import { formatShortDate } from '../../../../../helpers/dateHelper'
import MoneyText from '../../../../Text/Currency/MoneyText'
import DistanceText from '../../../../Text/Distance/DistanceText'

export default function TravelLineItem({ entity }: LineItemProps<TravelListItemDto>): ReactElement {
    return (
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 's1' }}>
            <Tooltip content={entity.user?.fullName} relationship="description" withArrow>
                <Avatar name={entity.user?.fullName} color="colorful" />
            </Tooltip>

            <Stack horizontal={false} verticalAlign="center" tokens={{ childrenGap: 's2 s1', padding: 's2 0' }} wrap>
                <Text>{entity.description}</Text>
                <Stack horizontal tokens={{ childrenGap: 's2' }}>
                    <Badge size="medium" icon={<CalendarMonthRegular />} appearance="tint">
                        {formatShortDate(entity.date)}
                    </Badge>
                    <Badge size="medium" icon={<VehicleCarProfileRegular />} appearance="tint">
                        <DistanceText value={entity.distance} />
                    </Badge>
                    <Badge size="medium" icon={<MoneyRegular />} appearance="tint">
                        <MoneyText value={entity.rate} textProps={{ size: 200 }} />
                    </Badge>
                </Stack>
            </Stack>
        </Stack>
    )
}
